<form [formGroup]="form" (submit)="handleSubmit()">
  <table>
    <thead>
      <tr>
        <th colspan="4">
          <div class="table-header">
            <span class="selection">{{ "Selection" | translate }}</span>
            <span>{{ "Odds" | translate }}</span>
            <span>{{ "Stake" | translate }}</span>
            @if (!isAsianHandicap) {
              <span> {{ "Profit" | translate }} / {{ "Loss" | translate }} </span>
            }
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="4">
          <div
            class="placement-form border-primary-2"
            [ngClass]="{
              'bg-back': initialData?.side === 'BACK',
              'bg-lay': initialData?.side === 'LAY',
            }">
            <div class="placement-row">
              <div class="runner">
                <mat-icon (click)="onCancel()" class="remove-icon" color="warn">close </mat-icon>
                <a
                  class="name text-primary"
                  [routerLink]="[
                    '/app/main',
                    {
                      outlets: {
                        navigation: ['event', initialData?.eventId],
                        content: ['event-markets', initialData?.eventId],
                      },
                    },
                  ]"
                  >{{ initialData?.runnerName }}</a
                >
              </div>
              <div class="odd-ipt">
                @if (initialData?.bettingType === "LINE") {
                  <span class="static-price">{{ form.value?.price | number: "1.0-2" }} </span>
                } @else {
                  <div class="custom-number-input" *featureFlag="'betEdit'; else readonly">
                    <input
                      min="1.01"
                      max="1000"
                      maxlength="7"
                      class="price-input"
                      [ngClass]="{
                        'invalid-odd-input': price?.invalid,
                      }"
                      formControlName="price"
                      type="text"
                      (keydown.arrowup)="handlePriceIncrement()"
                      (keydown.arrowdown)="handlePriceDecrement()"
                      (blur)="onPriceBlur()" />
                    <div class="button-container">
                      <button (focus)="priceButtonFocus = true" (blur)="priceButtonFocus = false" (click)="handlePriceIncrement()" type="button">
                        &#9650;
                      </button>
                      <button (focus)="priceButtonFocus = true" (blur)="priceButtonFocus = false" (click)="handlePriceDecrement()" type="button">
                        &#9660;
                      </button>
                    </div>
                  </div>
                }
                <ng-template #readonly>
                  <span class="static-price">{{ price?.value | number: "1.0-2" }}</span>
                </ng-template>
              </div>
              <div class="stake-ipt">
                <input maxlength="7" class="stake-input" formControlName="stake" type="text" />
              </div>
              @if (!isAsianHandicap) {
                <span class="pt-profit text-primary">{{ potentialProfit | number: "1.2-2" }}</span>
              }
            </div>
            @if (isAsianHandicap) {
              <app-ah-ladder-pnl [bet]="initialData" />
            }
            <div class="validation-messages">
              @if (price?.errors?.["invalidOdd"] || price?.hasError("required")) {
                <b class="invalid-odd">{{ "Invalid odd" | translate }}</b>
              }
              @if (userBalance < stake?.value || (isBalanceInsufficient && price?.touched && price?.dirty)) {
                <b class="invalid-odd">Insufficient Balance</b>
              }
            </div>
            <div class="persistence-type-input" [ngClass]="{ 'block-click': isGreyhound || priceChanged }">
              <label>
                <input formControlName="persistenceType" type="radio" name="persistenceType" value="PERSIST" required />
                Keep
              </label>
              <label>
                <input formControlName="persistenceType" type="radio" name="persistenceType" value="LAPSE" />
                Cancel
              </label>
            </div>
            <div class="submit-footer">
              <button
                class="cancel-button text-primary"
                [disabled]="($loading | async) || disableActions()"
                type="button"
                mat-button
                (click)="onCancel()">
                {{ "Cancel" | translate }}
              </button>
              @if (featureFlagService.featureFlags$ | async; as flags) {
                @if (flags["betEdit"]) {
                  <button
                    class="btn-place-bet text-primary bg-secondary"
                    [disabled]="
                      form.invalid ||
                      userBalance < stake?.value ||
                      (currentPrice === safeParseFloat(price?.value) && initialData?.persistenceType === persistenceType?.value) ||
                      isBalanceInsufficient ||
                      ($loading | async) ||
                      disableActions()
                    "
                    type="submit"
                    mat-button>
                    {{ "Update" | translate }}
                  </button>
                }
              }
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <div class="test-div" *featureFlag="'exposureCalculation'">
            <button mat-flat-button (click)="showDebugDialog($event)" type="button">Debug</button>
            <p>
              New Total Exposure:
              @if (debuggingService.exposureDebuggingObject | async; as debuggingObjects) {
                {{ getTotalExposureDebugging(debuggingObjects) | number: "1.0-2" }}
              }
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</form>
